module.exports = __webpack_public_path__ + "img/excel.041c7c91.svg";